import { BrowserRouter, Routes, Route } from "react-router-dom";
import DemoHub from "@/demo/DemoHub";
import AppDemo from "@/demo/AppDemo";
import IcebergPage from "@/demo/IcebergPage";
import GhostDriver from "@/demo/ghost/GhostDriver";
import DemoStats from "@/demo/DemoStats";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DemoHub />} />
        <Route path="/go/demo" element={<GhostDriver />} />
        <Route path="/app-demo" element={<AppDemo />} />
        <Route path="/iceberg" element={<IcebergPage />} />
        <Route path="/admin/demo-stats" element={<DemoStats />} />
        <Route path="*" element={<DemoHub />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
